$(()=> {

  let planQty = $('#plan_qty');

  planQty.on('focusout', async (e)=> {
    e.preventDefault();

    let el = $(e.currentTarget);
    let value = el.val();

    try {
      let response = await fetch('/plan/' + value);
      let data = await response.json();

      $('#total_price').text('S/ '+ data.price);
      $('#cant_user_2').text(data.quantity);

      if (!data.status) {
        $('#message-membership').show();
      } else {
        $('#message-membership').hide();
      }

    } catch (error) {
      console.error('error: ', error)
    }

  })
});
